import { render } from "./RegisterCourt.vue?vue&type=template&id=7019e2f0&scoped=true"
import script from "./RegisterCourt.vue?vue&type=script&lang=js"
export * from "./RegisterCourt.vue?vue&type=script&lang=js"

import "./RegisterCourt.vue?vue&type=style&index=0&id=7019e2f0&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7019e2f0"]])

export default __exports__